(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-bossnet-contact]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const panel = form.closest('[data-contact-bridge]');
      const submit = form.querySelector('[data-contact-submit]');
      const generalError = panel.querySelector('[data-contact-error]');
      const success = panel.querySelector('[data-contact-success]');
      const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]):not([name="website"]), textarea, select'));
      const originalLabel = submit.innerHTML;
      let sending = false;
      let completed = false;

      const fieldError = (field, message = '') => {
        const error = document.getElementById(field.getAttribute('aria-describedby'));
        if (error) {
          error.textContent = message;
          error.hidden = !message;
        }
        if (message) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      };
      const validate = (field) => {
        if (field.required && (field.type === 'checkbox' ? !field.checked : !field.value.trim())) {
          return field.type === 'checkbox'
            ? 'Confirmă că ai citit informarea privind datele personale.'
            : 'Completează acest câmp.';
        }
        if (field.validity.typeMismatch) return 'Introdu o adresă de email validă.';
        if (field.name === 'telefon' && field.value.trim()) {
          const value = field.value.trim();
          const digits = value.replace(/\D/g, '');
          if (!/^[+0-9(). \-]+$/.test(value) || digits.length < 7 || digits.length > 20) {
            return 'Introdu un număr de telefon valid.';
          }
        }
        if (!field.validity.valid) return 'Verifică informația completată.';
        return '';
      };
      fields.forEach((field) => {
        field.addEventListener('input', () => fieldError(field));
        field.addEventListener('change', () => fieldError(field));
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (sending || completed) return;
        generalError.hidden = true;
        let firstInvalid;
        fields.forEach((field) => {
          const message = validate(field);
          fieldError(field, message);
          if (message && !firstInvalid) firstInvalid = field;
        });
        if (firstInvalid) {
          firstInvalid.focus();
          return;
        }

        if (form.dataset.contactMode === 'email') {
          const data = Object.fromEntries(new FormData(form).entries());
          const body = [
            'Nume și prenume: ' + data.nume,
            'Email: ' + data.email,
            data.telefon ? 'Telefon: ' + data.telefon : '',
            data.numar_comanda ? 'Numărul comenzii: ' + data.numar_comanda : '',
            '',
            'Mesaj:',
            data.mesaj,
          ].filter((value) => value !== '').join('\n');
          const subject = 'Mesaj de pe site — ' + data.nume;
          const draft = 'mailto:' + form.dataset.contactEmail
            + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
          const status = form.querySelector('[data-contact-email-status]');
          if (status) status.hidden = false;
          window.location.href = draft;
          return;
        }

        sending = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = 'Se trimite…';
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 65000);
        const data = Object.fromEntries(new FormData(form).entries());
        data.pagina = window.location.origin + window.location.pathname;
        try {
          const response = await fetch(form.action, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            redirect: 'error',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            signal: controller.signal,
          });
          const result = await response.json();
          if (!response.ok || result.ok !== true) {
            if (result.fields && typeof result.fields === 'object') {
              fields.forEach((field) => {
                if (typeof result.fields[field.name] === 'string') fieldError(field, result.fields[field.name]);
              });
              const invalid = form.querySelector('[aria-invalid="true"]');
              if (invalid) {
                invalid.focus();
                return;
              }
            }
            throw new Error('Delivery failed');
          }
          completed = true;
          panel.querySelector('[data-contact-fields]').hidden = true;
          success.hidden = false;
          success.focus({ preventScroll: true });
          success.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        } catch (_error) {
          generalError.hidden = false;
        } finally {
          window.clearTimeout(timer);
          sending = false;
          submit.disabled = completed;
          submit.removeAttribute('aria-busy');
          submit.innerHTML = originalLabel;
        }
      });
      form.noValidate = true;
      submit.disabled = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
